const updateSelectedTestResults = (state, { data, type }) => {
  Object.assign(state, {
    selectedTestResults: {
      ...state.selectedTestResults,
      [type]: data
    }
  })
}

const setResultsBeingAnalyzed = (state, resultsBeingAnalyzed) => {
  Object.assign(state, { resultsBeingAnalyzed })
}
const clearResultsBeingAnalyzed = state => {
  Object.assign(state, {
    resultsBeingAnalyzed: {
      laboratory: {},
      images: {}
    }
  })
}

const clearSelectedTestResults = state => {
  Object.assign(state, {
    selectedTestResults: {
      laboratory: [],
      images: []
    }
  })
}

const clearSelectedResultsToAnalyze = state => {
  Object.assign(state, {
    selectedResultsToAnalyze: {
      laboratory: [],
      images: []
    }
  })
}

const clearTestResultFeedbackMessage = state => {
  Object.assign(state, {
    testResultFeedbackMessage: null
  })
}

const setSelectedResultsToAnalyze = (state, selectedResultsToAnalyze) => {
  Object.assign(state, { selectedResultsToAnalyze })
}

const setTestResultFeedbackMessage = (state, testResultFeedbackMessage) => {
  Object.assign(state, { testResultFeedbackMessage })
}

export default {
  updateSelectedTestResults,
  setResultsBeingAnalyzed,
  clearResultsBeingAnalyzed,
  clearSelectedTestResults,
  clearSelectedResultsToAnalyze,
  setSelectedResultsToAnalyze,
  clearTestResultFeedbackMessage,
  setTestResultFeedbackMessage
}
